import React from "react";
import ReactDOM from "react-dom";
import { hot } from 'react-hot-loader';
import App from './App';


const AppWithHot = hot(module)(App);

var mountNode = document.getElementById("root");
ReactDOM.render(<App />, mountNode);